import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import Button from '../../components/buttons/Button';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import { Link } from 'react-router-dom';
import { deleteCommnityApiCall, getCommunity } from '../../services/community';
import { BiCheck, BiCopy, BiEdit, BiRefresh, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { formatDate, formatDateTime } from '../../utils/FormatDateTime';
import { BsLink45Deg } from 'react-icons/bs';
import Dropdown from '../../components/inputFields/DropDown';
import { GoEye, GoEyeClosed } from 'react-icons/go';
import SearchBar from '../../components/searchBar/SearchBar';
import ReactPlayer from 'react-player';
import ConfirmModal from '../../components/popups/confirmationModal/ConfirmModal';
import { AiFillDelete } from 'react-icons/ai';

function Community() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [typeFilterStatus, setTypeFilterStatus] = useState("");
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [openingData, setOpeningData] = useState(null);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Date", key: "date" },
        { label: "Title", key: "title" },
        { label: "Posted By", key: "posted_by" },
        { label: "Is Active", key: "is_active" },
        { label: "File", key: "file" },
        { label: "F. Type", key: "file_type" },
        { label: "Type", key: "type" },
        { label: "Details", key: "details" },
    ];

    const pageSize = 100;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getCommunity(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch(() => {
                toast.error('Failed to copy address');
            });
    };

    const handleTypeFilterChange = (value) => {
        setTypeFilterStatus(value);
        if (value !== typeFilterStatus) {
            fetchData(`?type=${value}&search=${searchText}`);
        }
    };

    const handleSearch = (value) => {
        setSearchText(value);
        fetchData(`?search=${value}&type=${typeFilterStatus}`);
    };

    const resetFilters = () => {
        setTypeFilterStatus("");
        fetchData("");
    };

    const [openingItem, setOpeningItem] = useState(null);
    const [modalIsDeleteOpen, setIsDeleteOpen] = useState(false);

    const openDeleteModal = (item) => {
        setOpeningItem(item);
        setIsDeleteOpen(true);
    };

    // Close modal
    const closeDeleteModal = () => {
        setIsDeleteOpen(false);
        setOpeningItem(null);
    };

    const deletePost = (isConfirmDelete) => {
        if (isConfirmDelete) {
            deleteCommunity(openingItem.id);
            closeDeleteModal();
        }
    };

    const deleteCommunity = async (forumId) => {
        try {
            let res = await deleteCommnityApiCall(forumId);
            if (res.status === 204) {
                fetchData("");
                closeDeleteModal();
                toast.success("Forum deleted successfully");
            } else {
                toast.error("Unable to delete Forum");
            }
        } catch (error) {
            console.error("Error deleting Forum:", error);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Marketing' },
            { name: 'Community' },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-4 flex flex-row items-center gap-2">
                <StyledHeadingText text={"Community"} />
                <SearchBar placeholder="Search Title..." onSearch={handleSearch} value={searchText} />
                <div className="min-w-40">
                    <Dropdown
                        name="status"
                        options={[
                            { label: "All", value: "" },
                            { label: "General", value: "General" },
                            { label: "Updates", value: "Updates" },
                            { label: "News", value: "News" },
                            { label: "Scheme", value: "Scheme" },
                            { label: "New Products", value: "New Products" },
                        ]}
                        value={typeFilterStatus}
                        placeholder={"Select Type"}
                        onChange={handleTypeFilterChange}
                    />
                </div>
                {
                    typeFilterStatus.length !== 0 || searchText !== "" ?
                        <BiRefresh size={40} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                }
            </div>
            <Link to="/marketing/community/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Post
                </Button>
            </Link>
        </div>
        <>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading size={100} />
                    </div>
                    :
                    <div className="mt-2 flex flex-row w-full gap-2">
                        <div className="max-w-full w-full">
                            <Table
                                headers={headers}
                                rows={data?.results?.map((item, index) => ({
                                    i: <span className="text-gray-600">{(currentPage - 1) * pageSize + index + 1}</span>,
                                    date: <span className="text-gray-600">{formatDate(item.created_at)}</span>,
                                    title: (
                                        <div className="flex items-center gap-2">
                                            <span
                                                className="truncate max-w-xs hover:text-clip cursor-help"
                                                title={item.title}
                                            >
                                                {item.title}
                                            </span>
                                            <BiCopy
                                                className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                                onClick={() => copyClipboard(item.title)}
                                            />
                                        </div>
                                    ),
                                    posted_by: <span className="text-gray-600">{item.user === 5 ? "Self" : "Other"}</span>,
                                    is_active: (
                                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.is_active
                                            ? "bg-green-100 text-green-800"
                                            : "bg-red-100 text-red-800"
                                            }`}>
                                            {item.is_active ? "Active" : "Inactive"}
                                        </span>
                                    ),
                                    file: (
                                        <button
                                            onClick={() => window.open(item.file || item.youtube_link, "_blank")}
                                            className="text-blue-500 hover:text-blue-700 transition-colors"
                                        >
                                            <BsLink45Deg size={20} title="View file" />
                                        </button>
                                    ),
                                    type: <span className="text-gray-600">{item.type}</span>,
                                    details: (
                                        <div className="flex gap-3">
                                            <Link
                                                to={`/marketing/community/${item.slug}/`}
                                                state={item}
                                                className="text-blue-500 hover:text-blue-700 transition-colors"
                                                title="Edit"
                                            >
                                                <BiEdit size={18} />
                                            </Link>
                                            <button
                                                onClick={() => setOpeningData(openingData === item ? null : item)}
                                                className="text-purple-500 hover:text-purple-700 transition-colors"
                                                title={openingData === item ? "Hide preview" : "Preview"}
                                            >
                                                {openingData === item ? <GoEye size={18} /> : <GoEyeClosed size={18} />}
                                            </button>
                                            <button
                                                onClick={() => openDeleteModal(item)}
                                                className="text-red-500 hover:text-red-700 transition-colors"
                                                title="Delete"
                                            >
                                                <BiTrash size={18} />
                                            </button>
                                        </div>
                                    )
                                }))}
                            />

                            {
                                data.count !== 0 ?
                                    <div className="xl:pl-5 pl-0">
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={Math.ceil(data?.count / pageSize)}
                                            pageSize={pageSize}
                                            totalEntries={data?.count}
                                            onPageChange={handlePageChange}
                                            data={data}
                                            setData={setData}
                                        />
                                    </div> : <></>
                            }
                        </div>
                        {
                            openingData ?
                                <div className="fixed right-4 top-20 w-80 h-[calc(100vh-6rem)] bg-white rounded-lg shadow-xl border border-gray-200 flex flex-col overflow-hidden z-10">
                                    {/* Preview Header */}
                                    <div className="flex justify-between items-center p-3 border-b border-gray-200 bg-gray-50">
                                        <h3 className="font-medium text-gray-800">Post Preview</h3>
                                        <button
                                            onClick={() => setOpeningData(null)}
                                            className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-100"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Preview Content */}
                                    <div className="flex-1 overflow-y-auto p-4">
                                        {/* Media Preview */}
                                        <div className="mb-4">
                                            {["jpg", "jpeg", "png", "gif"].includes(openingData.file_type) ? (
                                                <img
                                                    src={openingData.file}
                                                    alt="Post preview"
                                                    className="w-full h-48 object-contain rounded-lg bg-gray-100 border border-gray-200"
                                                />
                                            ) : ["mp4", "mkv", "mov"].includes(openingData.file_type) ? (
                                                <video
                                                    src={openingData.file}
                                                    className="w-full h-48 object-contain rounded-lg bg-black"
                                                    controls
                                                    autoPlay
                                                    muted
                                                />
                                            ) : openingData.file_type === "pdf" ? (
                                                <iframe
                                                    src={openingData.file}
                                                    className="w-full h-48 rounded-lg border border-gray-200"
                                                    title="PDF Preview"
                                                />
                                            ) : openingData.file_type === "youtube" ? (
                                                <div className="w-full aspect-video rounded-lg overflow-hidden">
                                                    <ReactPlayer
                                                        url={openingData.youtube_link}
                                                        width="100%"
                                                        height="100%"
                                                        controls
                                                    />
                                                </div>
                                            ) : (
                                                <div className="w-full h-48 flex items-center justify-center bg-gray-100 rounded-lg border border-gray-200">
                                                    <p className="text-gray-500">Preview not available</p>
                                                </div>
                                            )}
                                        </div>

                                        {/* Post Details */}
                                        <div className="space-y-3">
                                            <div className="flex items-center justify-between">
                                                <StyledHeadingText
                                                    text={openingData.title}
                                                    className="text-lg font-semibold text-gray-800"
                                                />
                                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                                    {openingData.type}
                                                </span>
                                            </div>

                                            <div className="flex items-center text-sm text-gray-500 space-x-2">
                                                <span>{formatDate(openingData.created_at)}</span>
                                                <span>•</span>
                                                <span>{openingData.user === 5 ? "Posted by You" : "Posted by Other"}</span>
                                            </div>

                                            <div className="text-sm text-gray-700 whitespace-pre-line">
                                                {openingData.description}
                                            </div>

                                            <div className="pt-2 flex items-center space-x-2">
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${openingData.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                    }`}>
                                                    {openingData.is_active ? 'Active' : 'Inactive'}
                                                </span>
                                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                                                    {openingData.file_type.toUpperCase()}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer Actions */}
                                    <div className="p-3 border-t border-gray-200 bg-gray-50 flex justify-end space-x-2">
                                        <button
                                            onClick={() => window.open(openingData.file || openingData.youtube_link, "_blank")}
                                            className="px-3 py-1.5 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                                        >
                                            View Full Media
                                        </button>
                                        <Link
                                            to={`/marketing/community/${openingData.slug}/`}
                                            state={openingData}
                                            className="px-3 py-1.5 text-sm rounded-md bg-primary text-white hover:bg-primary/90"
                                        >
                                            Edit Post
                                        </Link>
                                    </div>
                                </div>
                                : <></>
                        }
                    </div>
            }
        </>
        <ConfirmModal
            isOpen={modalIsDeleteOpen}
            onRequestClose={closeDeleteModal}
            contentLabel=""
            onClose={closeDeleteModal}
            setIsConfirmDelete={deletePost}
            title="Are you sure to Delete?"
            icon={<AiFillDelete color="red" size={50} />}
        />
    </>);
}

export default Community;